import { render, staticRenderFns } from "./FoxButton.vue?vue&type=template&id=4a09f7eb&scoped=true&"
import script from "./FoxButton.vue?vue&type=script&lang=js&"
export * from "./FoxButton.vue?vue&type=script&lang=js&"
import style0 from "./FoxButton.vue?vue&type=style&index=0&id=4a09f7eb&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a09f7eb",
  null
  
)

export default component.exports